export const CHART_COLORS = ['#2196f3', '#ffeb3b', '#8bc34a', '#f44336', '#9c27b0', '#3f51b5', '#ffc107', '#607d8b', '#ff5722', '#009688', '#795548'];


export const PIE_COLOR_STRIP_1 = [
    '#845EC2',
    '#2C73D2',
    '#0081CF',
    '#0089BA',
    '#008E9B',
    '#008F7A',
];

export const PIE_COLOR_STRIP_2 = [
    '#18E5A3',
    '#00CEB4',
    '#00B6C0',
    '#009DC3',
    '#0082BD',
    '#0067AC',
];

export const PIE_COLOR_STRIP_3 = [
    '#FD8100',
    '#5A0000',
    '#FF9928',
    '#CD5A00',
    '#B64800',
];

export const PIE_COLOR_STRIP_4 = [
    '#A9490C',
    '#926400',
    '#757800',
    '#538830',
    '#1B945B',
    '#009D88',
];

export const PIE_COLOR_STRIP_5 = [
    '#B5C834',
    '#80BA3B',
    '#45AA46',
    '#009951',
    '#00865B',
    '#007362',
];

export const PIE_COLOR_STRIP_6 = [
    '#A3D9FF',
    '#F3D9DC',
    '#BEB7DF',
    '#7E6B8F',
    '#96E6B3',
    '#E2F89C',
];

export const REC_COLOR = '#6ead3a';
export const PAY_COLOR = '#ff5733';
